import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { formatDate } from '@shared/utils/dateFormat';

export interface OperationSummaryData {
  opType?: string;
  date?: string;
  resType?: string;
  subType?: string;
  resource?: string;
}

interface SummaryProps {
  summary: OperationSummaryData;
}

export const Summary: React.FC<SummaryProps> = ({ summary }) => {
  const formattedDate = summary.date && summary.date !== '—' && summary.date !== '-' ? formatDate(summary.date) : '—';
  const displayDate = formattedDate !== 'N/A' ? formattedDate : summary.date;

  const renderItem = (label: string, value?: string) => {
    const isFilled = Boolean(value && value !== '--' && value !== '-' && value !== '—' && value !== 'N/A');
    return (
      <div className="flex flex-col gap-1 text-sm">
        <div className="flex items-center gap-2 text-gray-500 font-medium text-xs tracking-wider">
          {isFilled ? (
            <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0" />
          ) : (
            <Circle className="w-4 h-4 text-gray-300 shrink-0" />
          )}
          <span>{label}</span>
        </div>
        <div className="text-gray-900 ml-6 font-medium text-sm">
          {isFilled ? value : '—'}
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-4">
      {/* Main Summary Card */}
      <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
        <h3 className="text-xs font-semibold text-gray-600 tracking-wider mb-5">
          Summary
        </h3>
        <div className="space-y-4">
          {renderItem('Operation Type', summary.opType)}
          {renderItem('Date', displayDate)}
          {renderItem('Resource Type', summary.resType)}
          {renderItem('Resource Sub Type', summary.subType)}
          {renderItem('Resource', summary.resource)}
        </div>
      </div>

      {/* What Happens Next Card */}
      <div className="bg-blue-50/70 p-5 rounded-xl border border-blue-100/80">
        <h4 className="text-sm font-semibold text-blue-900 mb-1.5">
          What happens next?
        </h4>
        <p className="text-xs text-blue-700 leading-relaxed">
          After creating the operation, open the detail view to complete the process — such as selecting a replacement resource.
        </p>
      </div>
    </div>
  );
};
